import React, { useRef, useEffect } from 'react';
import { animate } from 'animejs';
import { getWhatsAppUrl } from '../utils/links';
import { useLanguage } from '../context/LanguageContext';
import './Destinations.css';

const MAP_EMBED_URL = 'https://www.google.com/maps?q=Regi%C3%B3n+de+Antofagasta,+Chile&z=9&output=embed';

function Destinations() {
  const { lang, t } = useLanguage();
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        const items = section.querySelectorAll('.destinations-card');
        const mapEl = section.querySelector('.destinations-map');
        const btn = section.querySelector('.destinations-cta');
        items.forEach((el, i) => {
          animate(el, {
            opacity: [0, 1],
            y: [20, 0],
            duration: 500,
            delay: i * 80,
            ease: 'outExpo',
          });
        });
        if (mapEl) animate(mapEl, { opacity: [0, 1], duration: 600, delay: 300, ease: 'outExpo' });
        if (btn) animate(btn, { opacity: [0, 1], y: [12, 0], duration: 500, delay: 500, ease: 'outExpo' });
        observer.disconnect();
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  const destinations = t('destinations.items') || [];

  return (
    <div ref={sectionRef} className="destinations" id="lugares">
      <h2 id="lugares-title" className="section-title">{t('destinations.title')}</h2>
      <p className="destinations-subtitle">{t('destinations.subtitle')}</p>
      <div className="destinations-cards">
        {destinations.map((item, i) => (
          <article key={i} className="destinations-card">
            <span className="destinations-icon" aria-hidden="true">📍</span>
            <p className="destinations-text">{item}</p>
          </article>
        ))}
      </div>
      <div className="destinations-map-wrapper">
        <iframe
          className="destinations-map"
          title={t('destinations.mapTitle')}
          src={MAP_EMBED_URL}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
      <div className="destinations-cta-wrap">
        <a
          href={getWhatsAppUrl(lang)}
          className="destinations-cta"
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('destinations.btn')}
        >
          {t('destinations.btn')}
        </a>
      </div>
    </div>
  );
}

export default Destinations;
